import { useState } from "react";

import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import getEventPropertiesContentType from "@/view/utils/getEventPropertiesContentType";
import useLazyGetPolls from "@/view/utils/useLazyGetPolls";
import usePollSubmissionPost from "@/view/utils/usePollSubmissionPost";
import PollResponseCount from "../Poll/PollResponseCount";
import Poll from "../Poll";
import { footerCss } from "./StudentPollContainer.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  activePoll: PropTypes.shape({
    can_see_results: PropTypes.bool,
    data: PropTypes.object,
    id: PropTypes.string,
  }),
  contentType: PropTypes.string,
  isTeacher: PropTypes.bool,
  levelId: PropTypes.string,
  setAssignedPoll: PropTypes.func,
  userId: PropTypes.string,
};

const StudentPollContainer = ({
  activePoll,
  contentType,
  isTeacher = false,
  levelId,
  setAssignedPoll,
  userId,
}) => {
  const {
    can_see_results: canSeeResults,
    data: pollData,
    id: pollId,
  } = activePoll;
  const [selectedValue, setSelectedValue] = useState();
  const [submitPoll] = usePollSubmissionPost();
  const [fetchAssignmentPoll] = useLazyGetPolls();

  const handleSubmitResults = async () => {
    const payload = {
      data: { choice_id: selectedValue },
      activity: activePoll?.id,
    };
    await submitPoll(payload);
    const { data: updatedPoll } = await fetchAssignmentPoll({ pollId });
    setAssignedPoll(updatedPoll);
  };

  const submitPollButtonEventProperties = {
    objectType: "PollSubmission",
    actionName: "Create",
    streamProperties: {
      content_type: getEventPropertiesContentType(contentType),
      content_id: levelId,
      description: "Submit student poll answer",
    },
  };

  const footer = (
    <div css={footerCss(canSeeResults)}>
      {canSeeResults && <PollResponseCount isStudent pollData={pollData} />}
      <ButtonWithTrackEvent
        dataProps={{ "data-qa-selector": "student-submit-poll-results" }}
        disabled={canSeeResults || isTeacher}
        flavor={Button.flavors.primary}
        onClick={handleSubmitResults}
        {...submitPollButtonEventProperties}
      >
        {canSeeResults ? "Sent" : "Send"}
      </ButtonWithTrackEvent>
    </div>
  );

  const pollTitle = canSeeResults ? "See poll results" : "Choose a response";

  return (
    <Poll
      activePoll={activePoll}
      eyebrow="poll"
      footer={footer}
      isInteractive={!canSeeResults}
      setSelectedValue={setSelectedValue}
      title={pollTitle}
      userId={userId}
    />
  );
};

StudentPollContainer.propTypes = propTypes;

export default StudentPollContainer;
